import classnames from 'classnames';
import React from 'react';
import { ZHB_STEP_ITEM_PREFIX } from './const';
export var ZhbStepListItem = function ZhbStepListItem(props) {
  var title = props.title,
    desc = props.desc,
    rightNode = props.rightNode,
    indicator = props.indicator,
    rightClassName = props.rightClassName,
    rightStyle = props.rightStyle;
  return React.createElement("ul", {
    className: ZHB_STEP_ITEM_PREFIX
  }, React.createElement("li", {
    className: "".concat(ZHB_STEP_ITEM_PREFIX, "-left")
  }, React.createElement("i", {
    className: classnames("".concat(ZHB_STEP_ITEM_PREFIX, "-left-num"), "".concat(ZHB_STEP_ITEM_PREFIX, "-left-line"))
  }, indicator)), React.createElement("li", {
    className: "".concat(ZHB_STEP_ITEM_PREFIX, "-content")
  }, React.createElement("span", {
    className: "".concat(ZHB_STEP_ITEM_PREFIX, "-title")
  }, title), React.createElement("span", {
    className: "".concat(ZHB_STEP_ITEM_PREFIX, "-desc")
  }, desc)), rightNode && React.createElement("li", {
    className: classnames("".concat(ZHB_STEP_ITEM_PREFIX, "-right"), rightClassName),
    style: rightStyle
  }, rightNode));
};